import React from 'react';
import { Section, SectionTitle } from '../Section';
import { ImageSlot } from '../ImageSlot';
export function GuideSection() {
  return <Section tone="ink" data-id="element-79" data-mp="1kcmzry9cj2cb">
      <div className="grid gap-12 md:grid-cols-[5fr_6fr] md:items-center md:gap-12" data-id="element-80" data-mp="1kbbws0nq5ym9">
        <ImageSlot name="Beatriz Espina, la DOC" aspect="aspect-[3/4]" src="https://cdn.magicpatterns.com/uploads/brviboM8BVueo9yMauHn84/beatriz_en_vertical.png" data-id="element-81" data-mp="1y6nri81vrp36" />
        <div data-id="element-82" data-mp="15hyou4l6fbpb">
          <SectionTitle data-id="element-83" data-mp="11eaexf92o40w">
            Beatriz Espina, <em className="italic text-gold" data-id="element-84" data-mp="11fc4eoqu4t25">la DOC</em>
          </SectionTitle>
          <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ivory/90" data-id="element-85" data-mp="1fel8iq1rnwpr">
            <p data-id="element-86" data-mp="1af8kw332mlm4">
              Pedagoga, Magister en Ciencias de la Orientación de Conducta y en Sexología. 17 años educando sobre
              sexualidad, con un método claro, científico y sin juicios.
            </p>
            <p data-id="element-87" data-mp="2lux88vk8lmng">
              Su misión es que más personas entiendan su cuerpo, el de su pareja y el placer, con información real.
            </p>
          </div>
        </div>
      </div>
      <p className="mt-16 border-t border-gold/30 pt-10 text-center font-serif text-[2.4rem] leading-tight text-gold md:text-5xl" data-id="element-88" data-mp="xkl9d0y78cf5">
        17 años <span className="italic" data-id="element-89" data-mp="12khamsfihpr0">educando sin juicios</span>
      </p>
    </Section>;
}